export const GET_STATIC_BUNDLE_DETAIL = 'GET_STATIC_BUNDLE_DETAIL';

export const GET_STATIC_BUNDLE_DETAIL_SUCCESS = 'GET_STATIC_BUNDLE_DETAIL_SUCCESS';

export const GET_STATIC_BUNDLE_DETAIL_FAILED = 'GET_STATIC_BUNDLE_DETAIL_FAILED';

export const GET_PROMOTION_PRICE = 'GET_PROMOTION_PRICE';

export const GET_VARIANT_STATUS = 'GET_VARIANT_STATUS';